// extracted by mini-css-extract-plugin
export var container = "_9k-0";
export var icon = "_9k-1";
export var text = "_9k-2";